module.exports = __webpack_public_path__ + "img/introduce_title.e2076cf4.png";